import React, { Fragment, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button } from 'grommet';

import { postChangeStatus } from '../../../../api';
import { formatNumber } from '../../../../commons';
import { PageWrapper, Loading, ListLevel, Alert } from '../../../../components';

import { useForm, useMigrationSummary, useEnvironmentDetail } from '../../../../hooks';

import urlRoutes from '../../../../config/url-routes';

import { migrationStatus, messageDictionary } from '../../../../constants';

const FormRefuseMigration = () => {
  const { goBack, push } = useHistory();
  const { migrationId } = useParams();

  const { loading, data } = useMigrationSummary(migrationId);
  const { loading: loadingEnv, data: dataEnv } = useEnvironmentDetail(migrationId);
  const { values, errors, successful, submitting, handleSubmit, initialize } = useForm();

  useEffect(() => {
    initialize({
      migrationId,
      status: migrationStatus.analysisRefused,
    });
  }, [initialize, migrationId]); // Adiciona as dependências `initialize` e `migrationId`

  if(loading || loadingEnv) {
    return <Loading />;
  }

  if(successful || dataEnv.status !== migrationStatus.environmentReadyForAnalisys) {
    return (
      <PageWrapper>
        <div className='refuse-success'>
          <p className='refuse-success__message'>
            Verificamos que você não concordou com as informações, por favor, entre em contato com nossos atendentes pelo chat do intercom.
          </p>
        </div>

        <div className='refuse-actions'>
          <Button
            color='dark-3'
            label='Ok'
            onClick={() =>
              push(urlRoutes.migrationsUrl)
            }
          />
        </div>
      </PageWrapper>
    )
  }

  return (
    <PageWrapper>
      <div className='refuse-header'>
        <h2 className='refuse-header__title'>
          Deseja realmente RECUSAR essa migração?
        </h2>
      </div>

      <div className='refuse-summary'>
        <Fragment>
          <ListLevel
            title = 'Total de imóveis'
            value = {formatNumber(data.properties?.total)}
          />

          <ListLevel
            title = 'Total de clientes'
            value = {formatNumber(data.customers?.total)}
          />

          <ListLevel
            title = 'Total de empreendimentos'
            value = {formatNumber(data.enterprises?.total)}
          />

          <ListLevel
            title = 'Total de usuários'
            value = {formatNumber(data.brokers?.total)}
          />
        </Fragment>
      </div>

      {errors && (
        <div className='refuse-error'>
          <Alert alertType='error' message={messageDictionary.requestFail} />
        </div>
      )}

      <div className='refuse-actions'>
        <Button
          color='dark-3'
          label='Voltar'
          onClick={() =>
            goBack()
          }
        />

        <Button
          color='status-error'
          primary
          label={
            !submitting ? 'RECUSAR migração' : 'RECUSANDO migração...'
          }
          onClick={() =>
            handleSubmit({
              resource: postChangeStatus(values),
              callbackSuccess: null,
            })
          }
          disabled={submitting}
        />
      </div>
    </PageWrapper>
  )
}

export default FormRefuseMigration;
